import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "tags"]

  connect() {
    // Initialize tags from existing hidden inputs (for error states)
    const existingInputs = this.element.querySelectorAll('input[name="convo_message[phone_numbers][]"][value!=""]')
    existingInputs.forEach(input => {
      const phone = input.value
      if (phone && !this.tagsTarget.querySelector(`[data-phone-value="${phone}"]`)) {
        this.createTag(phone)
      }
      input.remove() // Remove the initial hidden input, we'll recreate them
    })
    this.updateHiddenInputs()
  }

  handleKeydown(event) {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault()
      this.addPhone()
    } else if (event.key === "Backspace" && this.inputTarget.value === "" && this.tagsTarget.children.length > 0) {
      this.removeLastTag()
    }
  }

  addPhone() {
    const value = this.inputTarget.value.trim()
    if (value === "") return

    // Basic phone number validation (allows various formats)
    const phoneRegex = /^[\d\s\-\(\)\+\.]+$/
    if (!phoneRegex.test(value)) {
      return
    }

    // Check if already exists
    const existingPhones = Array.from(this.tagsTarget.children).map(tag => 
      tag.dataset.phoneValue
    )
    if (existingPhones.includes(value)) {
      this.inputTarget.value = ""
      return
    }

    this.createTag(value)
    this.inputTarget.value = ""
    this.updateHiddenInputs()
  }

  removePhone(event) {
    event.preventDefault()
    const tag = event.currentTarget.closest(".phone-number-tag")
    if (tag) {
      tag.remove()
      this.updateHiddenInputs()
    }
  }

  removeLastTag() {
    const lastTag = this.tagsTarget.lastElementChild
    if (lastTag) {
      lastTag.remove()
      this.updateHiddenInputs()
    }
  }

  createTag(phone) {
    const tag = document.createElement("div")
    tag.className = "phone-number-tag"
    tag.dataset.phoneValue = phone
    tag.innerHTML = `
      <span>${this.formatPhone(phone)}</span>
      <button type="button" class="tag-remove" data-action="click->phone-numbers#removePhone">
        <i class="bi bi-x"></i>
      </button>
    `
    this.tagsTarget.appendChild(tag)
  }

  formatPhone(phone) {
    // Simple formatting: (XXX) XXX-XXXX
    const cleaned = phone.replace(/\D/g, "")
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
    } else if (cleaned.length === 11 && cleaned[0] === "1") {
      return `(${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`
    }
    return phone
  }

  updateHiddenInputs() {
    // Remove all existing hidden inputs with name phone_numbers
    const existingInputs = this.element.querySelectorAll('input[name="convo_message[phone_numbers][]"]')
    existingInputs.forEach(input => {
      input.remove()
    })

    // Add new hidden inputs for each tag
    const phones = Array.from(this.tagsTarget.children).map(tag => tag.dataset.phoneValue)
    phones.forEach((phone) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "convo_message[phone_numbers][]"
      input.value = phone
      this.element.appendChild(input)
    })
  }
}
